<template>
  <div class="playerLog">
    <AdminNavBar/>

    <main v-if="player && log" role="main" class="ml-sm-auto px-4">
      <template>
        <b-breadcrumb>
          <b-breadcrumb-item to="/players"
            ><b-icon-collection-play-fill></b-icon-collection-play-fill>
            Players</b-breadcrumb-item
          >
          <b-breadcrumb-item :to="'/player/' + player._id" v-if="player">{{
            player.username
          }}</b-breadcrumb-item>
          <b-breadcrumb-item active>{{
            log.caseInfo.codename + ' ' + log.caseInfo.name
          }}</b-breadcrumb-item>
        </b-breadcrumb>
      </template>

      <b-card>
        <dl class="row">
          <dt class="col-sm-2 text-right">Score</dt>
          <dd class="col-sm-10">{{formatScore(log.score)}}</dd>

          <dt class="col-sm-2 text-right">Status</dt>
          <dd class="col-sm-10">{{log.status}}</dd>

          <dt class="col-sm-2 text-right">Pass score</dt>
          <dd class="col-sm-10">{{log.pass_score}}</dd>

          <dt class="col-sm-2 text-right">Start time</dt>
          <dd class="col-sm-10" :title="log.start_timestamp">{{ dayjs(log.start_timestamp).format(DATETIME_FORMAT) }}</dd>

          <dt class="col-sm-2 text-right">End time</dt>
          <dd class="col-sm-10" :title="log.end_timestamp">{{ dayjs(log.end_timestamp).format(DATETIME_FORMAT) }}</dd>

          <dt class="col-sm-2 text-right">Time played</dt>
          <dd class="col-sm-10">
            {{(log.end_timestamp - log.start_timestamp) ? dayjs.duration(log.end_timestamp - log.start_timestamp).format(TIME_FORMAT) : 'NA'}}
            {{ log.time_played && log.time_played !== -1 ? ` (logged=${dayjs.duration(log.time_played * 1000).format(TIME_FORMAT)})` : '' }}
          </dd>
          
          <dt class="col-sm-2 text-right">Debrief</dt>
          <dd class="col-sm-10">{{log.debrief == null ? 'NA' : log.debrief ? 'Yes' : 'No'}}</dd>

          <dt class="col-sm-2 text-right">Details</dt>
          <dd class="col-sm-10">
            <b-table class="mb-0" striped hover small fixed head-variant='dark' :items="items"></b-table>
            <small>* provides prior information</small>
          </dd>
          <dt class="col-sm-2 text-right">Game</dt>
          <dd class="col-sm-10">
            <div v-if="log.gameInfo">
              <b-link @click="
                $router.push({ name: 'game', params: { id: log.game_id } })
              ">{{log.gameInfo.name}}</b-link>
            </div>
            <div v-else>NA</div>
          </dd>
          <dt class="col-sm-2 text-right">Case</dt>
          <dd class="col-sm-10">
            <b-link @click="
                $router.push({ name: 'case', params: { id: log.case_id } })
              ">{{log.caseInfo.codename}} {{log.caseInfo.name}}</b-link>
          </dd>          
        </dl>
          <b-button class="mr-2" @click="play(log)" variant="warning">
            <b-icon-play></b-icon-play>Review in game</b-button
          >
      </b-card>
    </main>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";
import dayjs from "dayjs";

const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

import AdminNavBar from '../components/AdminNavBar';

import { IconsPlugin } from "bootstrap-vue";
Vue.use(IconsPlugin);

import { cloneDeep } from "lodash";

const {isFinalized} = require ('../play-utils');

export default {
  name: "playerLog",
  components: {
    AdminNavBar,
  },
  data: function () {
    return {
      player: null,
      log: null,
      items: [],
      dayjs: dayjs,
      DATETIME_FORMAT: process.env.VUE_APP_DATETIME_FORMAT,
      TIME_FORMAT: process.env.VUE_APP_TIME_FORMAT
    };
  },
  methods: {
    formatScore(score) {
      return (typeof score === 'number') ? score == 0 ? 0 : score == 1 ? 1 : score.toFixed(2) : 'Need repair';
    },
    play(log) {
      const defaults = JSON.parse(process.env.VUE_APP_PLAY_DEFAULTS);
      axios
        .post(
          process.env.VUE_APP_API_URL + '/cases/list',
          { _ids: [log.case_id]},
          { headers: { authorization: localStorage.getItem('vle.user.token') } }
        )
        .then(response => {
          const caseInfos = response.data;

          this.$store.commit('playData', {
            token: localStorage.getItem('vle.user.token'),            
            game: {
              name: this.player.username + ' ' + log.caseInfo.codename + ' ' + log.caseInfo.name,
              time: defaults.time,
              replay: true,
              debrief: true,
              cases: [log.case_id],
              _id: log.game_id
            },
            caseInfos: caseInfos,
            player: { username: this.$store.state.user.username, logs: [log] },
            debug: true,
          });
          let route = this.$router.resolve('/testPlay');
          window.open(route.href, '_blank');
        });
    },
  },
  mounted() {
  axios
    .post(
      process.env.VUE_APP_API_URL + '/players/getInfos',
      { _id: this.$route.params.id },
      { headers: { authorization: localStorage.getItem('vle.user.token') } }
    )
    .then(result => {
      this.player = result.data;
      this.log = cloneDeep(this.player.logs.find(d => d.log_id === this.$route.params.log_id));
      let log = this.log;
      log.status = isFinalized(log) ? log.pass ? 'Pass' : 'Fail' : 'Paused';

      console.log(this.log.time_played)
      console.log(this.TIME_FORMAT)
      console.log(dayjs.duration(this.log.time_played * 1000).format(this.TIME_FORMAT))


      for (let i = 0; i < log.data.length; i++) {
        let d = log.data[i];
        let c = log.caseInfo.data[i];
        this.items.push({
          document: c.name + (c.prior ? '*' : ''),
          seen: d.seen ? 'Yes' : 'No',
          finalized: d.choices ? d.finalized ? 'Yes' : 'No' : 'NA',
          score: this.formatScore(d.score)
        });
      }
    });
  },
};
</script>

